import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  tone?: 'light' | 'dark';
}

export default function Breadcrumb({ items, tone = 'light' }: BreadcrumbProps) {
  const onDark = tone === 'dark';
  const base = onDark ? 'text-white/70' : 'text-foreground-500';
  const hover = onDark ? 'hover:text-accent-300' : 'hover:text-primary-600';
  const arrow = onDark ? 'text-white/40' : 'text-foreground-300';
  const current = onDark ? 'text-white font-medium' : 'text-foreground-800 font-medium';

  return (
    <nav aria-label="面包屑导航" className={`flex items-center flex-wrap gap-1.5 text-sm ${base}`}>
      <Link to="/" className={`${hover} transition-colors flex items-center gap-1`}>
        <i className="ri-home-4-line"></i> 首页
      </Link>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <i className={`ri-arrow-right-s-line ${arrow}`}></i>
          {item.to ? (
            <Link to={item.to} className={`${hover} transition-colors`}>
              {item.label}
            </Link>
          ) : (
            <span className={current}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}